export default __webpack_public_path__ + "static/creative-community-25f3d867f3ef03caa67975586caab1bf.png";